import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/evcs_traces',
  component: Management,
  redirect: '/evcs_traces/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/evcs_traces/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listEvcsTraces
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/evcs_traces/ListTable'),
          meta: {
            auth: Auth.listEvcsTraces,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
